import { Pipe, PipeTransform } from '@angular/core';

/**
 * 將電話號碼4碼後的數字隱碼
 */
@Pipe({
  name: 'maskPhone',
  standalone: true,
})
export class MaskPhonePipe implements PipeTransform {
  transform(value: string): unknown {
    if (!value) {
      return value;
    }

    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(value)) {
      return value;
    }

    // 將第4位之後的數字替換為*
    return value.substring(0, 4) + '*'.repeat(value.length - 4);
  }
}
